import { createSlice } from '@reduxjs/toolkit';
import * as Api from '../Api';

export const searchSlice = createSlice({
  name: 'search',
  initialState: {
    distanceResponse: [],
  },
  reducers: {
    setDistanceResponse: (state, action) => {
      state.distanceResponse = action.payload;
    },
  },
});

export function getDistance(search, contents) {
  return async (dispatch) => {
    var response = await Api.postRequest(
      '/zipservice/distancelist/?center=' + search + '&zipList=' + contents,
      'POST',
      {},
    );
    dispatch(setDistanceResponse(response));
  };
}

export const { setDistanceResponse } = searchSlice.actions;
export const setDistanceSelector = (state) => state.search.distanceResponse;
export default searchSlice.reducer;
